import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
import type { PerformanceDatapoint } from 'owa-analytics';

export const addCalendarFormPerfDatapoint = mutatorAction(
    'addCalendarFormPerfDatapoint',
    (formId: string, datapoint: PerformanceDatapoint) => {
        getStore().formIdToDatapointMap.set(formId, datapoint);
    }
);

export const removeCalendarFormPerfDatapoint = mutatorAction(
    'removeCalendarFormPerfDatapoint',
    (formId: string) => {
        getStore().formIdToDatapointMap.delete(formId);
    }
);
